var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScrollToBottom = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16.001"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144544",
  fill: "none",
  d: "M16 .001v16H0v-16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.301 13.269V.821a.794.794 0 01.236-.585A.794.794 0 018.122 0a.794.794 0 01.585.236.8.8 0 01.236.585v12.448l5.656-5.656a.771.771 0 01.571-.241.813.813 0 01.582.258.857.857 0 01.246.577.765.765 0 01-.246.577l-6.937 6.937a.908.908 0 01-.324.217 1.052 1.052 0 01-.368.063 1.052 1.052 0 01-.368-.063.908.908 0 01-.324-.217L.494 8.784a.783.783 0 01-.233-.563.818.818 0 01.233-.59.8.8 0 01.585-.255.8.8 0 01.585.255z",
  fill: "#f8a13a"
})));
export default __webpack_public_path__ + "static/ScrollToBottom.76f9bef51fd0eccf563a0597312afffd.svg";
export { SvgScrollToBottom as ReactComponent };